import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { InfoCard } from 'components'
import { useFirebaseEvent } from 'hooks'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import './style.scss'

export function PersonalInfoCard() {
  const formattedAddress = useSelector(state => {
    const { address } = state.contract.selected
    const { city, number, street, type, uf, zipCode } = address

    return {
      city: city?.toLowerCase(),
      number,
      street: street?.toLowerCase(),
      type: type?.toLowerCase(),
      uf,
      zipCode,
    }
  })
  const { city, number, street, type, uf, zipCode } = formattedAddress
  const { name } = useSelector(state => state.customer.info)
  const lowerCaseName = name?.toLowerCase() || ''
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  function handleChangeAddressClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_ADDRESS_CHANGE)
    dispatch(setDrawer(DRAWER_KEY.ADDRESS_CHANGE))
  }

  function handleOpenPhoneDrawer() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_SEE_PHONES)
    dispatch(setDrawer(DRAWER_KEY.PHONE))
  }

  function handleOpenEmailDrawer() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_SEE_EMAILS)
    dispatch(setDrawer(DRAWER_KEY.EMAIL))
  }

  return (
    <InfoCard
      title='Meus dados cadastrais'
      actions={[
        {
          icon: <STATICS.PHONE />,
          label: 'Meus telefones',
          onClick: handleOpenPhoneDrawer,
        },
        {
          icon: <STATICS.ENVELOPE />,
          label: 'Meus e-mails',
          onClick: handleOpenEmailDrawer,
        },
      ]}
    >
      <div className='customer-address-info'>
        <div className='customer-name'>
          <p>{lowerCaseName}</p>
        </div>
        <div className='customer-address'>
          <p>
            <strong>Meu endereço</strong>
          </p>
          <p>
            {type} {street}, {number} - {city}, {uf}
          </p>
          <p>CEP: {zipCode}</p>
          <button
            type='button'
            className='change-address-button'
            onClick={handleChangeAddressClick}
          >
            Alterar endereço de instalação &gt;
          </button>
        </div>
      </div>
    </InfoCard>
  )
}
